import { connect } from 'react-redux';
import { State } from 'store/state';
import { PocType } from 'utils/entities';
import { Dispatch } from 'redux';
import { RootAction } from 'store/state';
import { Poi, isBulletinPoiType, isProjectPoiType } from 'utils/marketplaceRoutes';
import { contactAgentInputClick, submitContactAgent } from 'store/state/app/actions';
import { SubmitContactAgentPayload } from 'store/state/app/payloads';
import withEvents from 'analytics/withEvents';
import { IContactPageSubmitVariables } from 'store/sagas/apiService/types';
import { RequestType } from 'components/contact-modal/HebrewContactModal';
import {
  getContactPageEventPayload,
  contactFormInitialValuesSelector,
  getPOCPhoneNumber,
  getProjectPhoneNumber,
} from 'helpers/contact';
import { ContactButtons, ContactButtonsProps } from './contact-buttons';
import { poiSelector } from 'components/contact/makeContactMapStateToPropsFactory';

const ContactButtonsWithEvents = withEvents<ContactButtonsProps>((sendEvent, props) => ({
  onCallClickEvent: (isVisible: boolean, formValues: IContactPageSubmitVariables, source?: string) => {
    const contactDetails = getContactPageEventPayload(isBulletinPoiType(props.poi) && props.poi.poc, formValues, isVisible);
    const event = {
      ...contactDetails.event,
      ...(source ? { source } : null),
      ...('poc' in props.poi && props.poi.poc && props.poi.poc.type === PocType.Agent && !isVisible ? {
        agent_details: {
          id: props.poi.poc.agentId,
          office_id: props.poi.poc.officeId,
        },
      } : null),
    };

    sendEvent(isVisible ? 'property_lead_call_submit' : 'property_lead_phone_expose', 'property', {
      ...contactDetails,
      event,
      bulletinId: props.poi.id,
      rtbData: {
        phone: isBulletinPoiType(props.poi) && getPOCPhoneNumber(props.poi.poc) || isProjectPoiType(props.poi) && getProjectPhoneNumber(props.poi),
      },
    });
  },
  handleSubmitEvent: (hasErrors: boolean, formValues: IContactPageSubmitVariables, source?: string) => {
    const contactDetails = getContactPageEventPayload(isBulletinPoiType(props.poi) && props.poi.poc, formValues, null, RequestType.RequestInfo);

    const event = {
      ...contactDetails.event,
      ...(source ? { source } : null),
    };

    sendEvent(hasErrors ? 'property_lead_form_submit_attempt' : 'property_lead_form_submit', 'property', {
      ...contactDetails,
      event,
      bulletinId: props.poi.id,
    });
  },
}))(ContactButtons);


const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onContactPageSubmit: (payload: SubmitContactAgentPayload) => dispatch(submitContactAgent(payload)),
  onContactAgentInputClick: (eventName: string, poi: Poi) => dispatch(contactAgentInputClick({ eventName, poi })),
});

const mapStateToProps = (state: State) => ({
  contactValues: contactFormInitialValuesSelector(state),
  poi: poiSelector(state),
});

const ConnectedContactButtons = connect(mapStateToProps, mapDispatchToProps)(ContactButtonsWithEvents);

export default ConnectedContactButtons;
